export const NoEntity = () => {
	return (
		<div className="flex h-full w-full select-none items-center justify-center">
			<img src="/images/no-entity.png" className="h-60 w-auto" draggable={false} />
		</div>
	);
};
